import http from "../http/http-config";
import { AP24HsQuotationResponse } from "../models/AP24HsQuotationResponse";

export default new class getNewAP24HsQuotation {
    createNewAP24HsQuotation(model: Record<string, unknown>): Promise<AP24HsQuotationResponse> {
        return http.post<AP24HsQuotationResponse>(
            "NewAP24HsQuotation/GetAP24HsQuotation",
            model,
            { headers: { "Content-Type": "application/json" } }
        ).then(response => response.data);
    }
}
